import { render } from "./TheSearchImage.vue?vue&type=template&id=5606c5a6&scoped=true&ts=true"
import script from "./TheSearchImage.vue?vue&type=script&lang=ts"
export * from "./TheSearchImage.vue?vue&type=script&lang=ts"

import "./TheSearchImage.vue?vue&type=style&index=0&id=5606c5a6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5606c5a6"]])

export default __exports__